import {post} from "./base";

export async function askToAgent(accessToken, data) {
    const result = await post("ag_assistant/AskToAgent", { jsonBody: {accessToken, data}});
    return result;
}
